<template>
  <div class="px-3 py-2 lightgrey text-right flex-grow-1 flex-shrink-0" style="white-space: nowrap">
    <div class="body-1 font-weight-medium">
      {{ text }}
    </div>
    <div class="text-title-small">
      {{ subtext }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: { type: [String, Number], required: true },
    subtext: { type: String, required: true }
  }
}
</script>
